import { MF_EXECUTION_IMAGE_URL } from '../../constants'
import {
  ExecutionLearnMoreReason,
  TransferLearnMoreReason,
  WithdrawalLearnMoreReason
} from '../../types/mf-execution.types'

const methodPausedIcon = `${MF_EXECUTION_IMAGE_URL}/method-paused.svg`
const lockInIcon = `${MF_EXECUTION_IMAGE_URL}/in-lock-in.svg`
const pledgedIcon = `${MF_EXECUTION_IMAGE_URL}/units-pledged.svg`
const dematIcon = `${MF_EXECUTION_IMAGE_URL}/in-demat.svg`
const notPossibleIcon = `${MF_EXECUTION_IMAGE_URL}/method-not-possible.svg`

export function getExecutionLearnMoreConfig(reason: ExecutionLearnMoreReason): {
  icon?: string
  heading: string
  content: string
} {
  switch (reason) {
    case ExecutionLearnMoreReason.INVESTMENT_PAUSED:
      return {
        icon: methodPausedIcon,
        heading: 'Investments are paused by the fund house',
        content:
          'Fund house has paused the purchase of new units in this fund at the moment. Tap below to get notified as soon as they resume.'
      }
    case ExecutionLearnMoreReason.WITHDRAWAL_PAUSED:
      return {
        icon: methodPausedIcon,
        heading: 'Withdrawals are paused by the fund house',
        content:
          'Fund house has paused the sale of units in this fund at the moment. Tap below to get notified as soon as they resume.'
      }
    case ExecutionLearnMoreReason.NEW_ORDERS_PAUSED:
      return {
        icon: methodPausedIcon,
        heading: 'New orders are paused by the fund house',
        content:
          'Fund house has paused the purchase and sale of new units in this fund at the moment. Tap below to get notified as soon as they resume.'
      }
    case ExecutionLearnMoreReason.REGULAR:
      return {
        heading: 'Transactions not supported for Regular Plans',
        content: `Regular Plan investments and withdrawals are not supported on PowerUp Money. We only support Direct Plans.`
      }
    case ExecutionLearnMoreReason.SIP_PAUSED:
      return {
        icon: methodPausedIcon,
        heading: 'SIP requests paused by fund house',
        content:
          'Fund house has paused all SIP requests in this fund at the moment. Tap below to get notified as soon as they resume.'
      }
    case ExecutionLearnMoreReason.ONE_TIME_PAUSED:
      return {
        icon: methodPausedIcon,
        heading: 'One-time investments are paused by the fund house',
        content:
          'Fund house has paused all one-time investment requests in this fund at the moment. Tap below to get notified as soon as they resume.'
      }
    case ExecutionLearnMoreReason.GENERIC:
    default:
      return {
        icon: methodPausedIcon,
        heading: 'Learn More',
        content: 'More information about this action will be available soon.'
      }
  }
}

export function getWithdrawalLearnMoreConfig(reason: WithdrawalLearnMoreReason): {
  icon: string
  heading: string
  content: string
} {
  switch (reason) {
    case WithdrawalLearnMoreReason.LOCKIN:
      return {
        icon: lockInIcon,
        heading: "This fund can't be withdrawn as it's still under lock-in",
        content:
          'You will be able to withdraw from this fund once the lock-in period is over. Please check the lock-in details in the investment section.'
      }
    case WithdrawalLearnMoreReason.PLEDGED:
      return {
        icon: pledgedIcon,
        heading: "This fund can't be withdrawn as its units are pledged",
        content: 'You will be able to remove the pledge from the respective institution and withdraw again.'
      }
    case WithdrawalLearnMoreReason.DEMAT:
      return {
        icon: dematIcon,
        heading: "This fund can't be withdrawn as its units are in a demat account",
        content: 'Units held in a demat account cannot be withdrawn directly. Please check your demat broker platform.'
      }
    case WithdrawalLearnMoreReason.CAN_NOT_WITHDRAW:
      return {
        icon: notPossibleIcon,
        heading: "This fund can't be withdrawn as its units are under lock-in and pledged",
        content: 'You will be able to withdraw after the lock-in period is over and the pledge is removed.'
      }
    case WithdrawalLearnMoreReason.GENERIC:
    default:
      return {
        icon: notPossibleIcon,
        heading: 'Learn More',
        content: 'More information about this action will be available soon.'
      }
  }
}

export function getTransferLearnMoreConfig(reason: TransferLearnMoreReason): {
  icon: string
  heading: string
  content: string
} {
  switch (reason) {
    case TransferLearnMoreReason.LOCKIN:
      return {
        icon: lockInIcon,
        heading: 'This fund can’t be transferred as it’s still under lock-in',
        content: 'You’ll be able to transfer from this fund once your lock-in period ends.'
      }
    case TransferLearnMoreReason.PLEDGED:
      return {
        icon: pledgedIcon,
        heading: 'This fund can’t be transferred as its units are pledged',
        content: 'You will have to remove the pledge from the respective platform before transferring again.'
      }
    case TransferLearnMoreReason.DEMAT:
      return {
        icon: dematIcon,
        heading: 'This fund can’t be transferred as its units are in a demat account',
        content:
          'Since demat units can’t be transferred externally, please transfer directly using the broker platform.'
      }
    case TransferLearnMoreReason.CAN_NOT_TRANSFER:
      return {
        icon: notPossibleIcon,
        heading: 'This fund can’t be transferred ',
        content:
          'Your fund can’t be transferred because it’s either locked in, held in an external demat account, or pledged. Please check if these exist and try again.'
      }
    case TransferLearnMoreReason.GENERIC:
    default:
      return {
        icon: notPossibleIcon,
        heading: 'Learn More',
        content: 'More information about this action will be available soon.'
      }
  }
}
